const STORAGE_KEY = 'competition_entries';

/**
 * Returns all locally persisted competition entries.
 * @returns {{ competitionId: string, entryDate: string }[]}
 */
export function getPersistedCompetitionEntries() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch {
    return [];
  }
}

/**
 * Persists a new competition entry to local storage.
 * @param {string} competitionId
 * @param {boolean} accountRequired
 */
export function persistCompetitionEntry(competitionId, accountRequired = false) {
  try {
    const existing = getPersistedCompetitionEntries();
    if (existing.some(e => e.competitionId === competitionId)) return;
    const updated = [...existing,
      { competitionId, entryDate: new Date().toISOString(), accountRequired }];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(updated));
  } catch { /**/ }
}

/**
 * Removes only verified (account-required) entries from local storage,
 * preserving device-local unverified entries across logout.
 */
export function clearVerifiedPersistedCompetitionEntries() {
  try {
    const remaining = getPersistedCompetitionEntries().filter(e => !e.accountRequired);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(remaining));
  } catch { /**/ }
}
